// extracted by mini-css-extract-plugin
export var container = "_v1-0";
export var table = "_v1-2";
export var tableWrapper = "_v1-1";